import { render, staticRenderFns } from "./Layout-sub.vue?vue&type=template&id=7b96808b&scoped=true&"
import script from "./Layout-sub.vue?vue&type=script&lang=ts&"
export * from "./Layout-sub.vue?vue&type=script&lang=ts&"
import style0 from "./Layout-sub.vue?vue&type=style&index=0&id=7b96808b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b96808b",
  null
  
)

export default component.exports